import React, { useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Banner from '../../assets/images/banner.png';
import product1 from '../../assets/images/shoes.png';
import product2 from '../../assets/images/shoes2.png';
import product3 from '../../assets/images/shoes3.png';
import product4 from '../../assets/images/shoes4.png';
import product5 from '../../assets/images/shoes5.png';
import product6 from '../../assets/images/shoes6.png';
import card1 from '../../assets/images/kid2.png';
import card2 from '../../assets/images/kid3.png';
import card3 from '../../assets/images/kid4.jpeg';
import card4 from '../../assets/images/kid5.jpeg';
import moccasin from '../../assets/images/Pumps_medium.jpg';
import courtShoes from '../../assets/images/Moccasin_medium.jpg';
import backOpen from '../../assets/images/Back-open_medium.jpg';
import sneakers from '../../assets/images/courtshoes_medium.jpg';
import pumps from '../../assets/images/Pumps.jpg';

function Preview({primaryColor,secColor}) {
    const [hoveredIndex, setHoveredIndex] = useState(null);
    
    const products = [
        {
            id: 1,
            image: card1,
            title: 'Product 1',
            description: 'High-quality product with best price',
            price: 'Rs. 2,689',
            rating: '⭐⭐⭐⭐⭐ (1.4K sold)'
        },
        {
            id: 2,
            image: card2,
            title: 'Product 2',
            description: 'Durable and stylish, perfect for your needs',
            price: 'Rs. 2,140',
            rating: '⭐⭐⭐⭐ (14 sold)'
        },
        {
            id: 3,
            image: card3,
            title: 'Product 3',
            description: 'Premium quality, best for home & office',
            price: 'Rs. 3,200',
            rating: '⭐⭐⭐⭐⭐ (3.5K sold)'
        },
        {
            id: 4,
            image: card4,
            title: 'Product 4',
            description: 'Affordable & reliable choice for everyone',
            price: 'Rs. 1,999',
            rating: '⭐⭐⭐⭐ (2.2K sold)'
        }
    ];

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    };

    const settings3 = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    };

    const images = [product1, product2, product3, product4, product5, product6];

    const image = [card1, card2, card3, card4];

    const categories = [
        { id: 1, image: pumps, name: 'PUMPS' },
        { id: 1, image: moccasin, name: 'MOCCASIN' },
        { id: 2, image: courtShoes, name: 'COURT SHOES' },
        { id: 3, image: backOpen, name: 'BACK OPEN' },
        { id: 4, image: sneakers, name: 'SNEAKERS' }
    ];

    const settings2 = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: { slidesToShow: 3 }
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 2 }
            },
            {
                breakpoint: 480,
                settings: { slidesToShow: 1 }
            }
        ]
    };
    return (
        <>
            <div className="template1__container">
                {/* Upper Banner */}
                <div className="template1__banner">
                    <img src={Banner} alt="Upper Banner" className="template1__upperbanner" />
                </div>

                <div className="latest-arrivals mb-7 mt-7">
                    <h2 style={{ color: `${primaryColor}` }}>NEW ARRIVALS</h2>
                </div>
                <div className="category-slider">
                    <Slider {...settings2}>
                        {categories.map((category) => (
                            <div key={category.id} className="category-item">
                                <div className="category-image">
                                    <img src={category.image} alt={category.name} />
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>

                {/* Lower Banner */}
                <div className="latest-arrivals mb-5 mt-8">
                    <h2 style={{ color: `${primaryColor}` }}>STORE COLLECTION</h2>
                </div>

                <div className="template1__container mb-5">
                    <div className="grid__section">
                        {images.map((img, index) => (
                            <div key={index} className="template1__card">
                                <img src={img} alt={`Product ${index + 1}`} className="template1__product" />
                            </div>
                        ))}

                        {products.map((product, index) => (
                            <div key={product.id} className="template1__card" onMouseEnter={() => setHoveredIndex(index)} onMouseLeave={() => setHoveredIndex(null)}>
                                <img src={product.image} alt={product.title} className="template1__product" />
                                {hoveredIndex === index && (
                                    <div className="product__overlay">
                                        <h4 className="mt-8" style={{color:`${primaryColor}`}}>{product.title}</h4>
                                        <p style={{color:`${secColor}`}}>{product.description}</p>
                                        <p>{product.price}</p>
                                        <p>{product.rating}</p>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}

export default Preview;
